import {PERMISSION_ALIASES} from 'core/constants/permissionAliases';
import {permissions$} from 'models/auth';
import {UserPermission} from 'types';

export function getBillingAccess(permissions: readonly string[]) {
    const has = (permission: string) => permissions.includes(permission);
    const canViewOwnTransactions = has(PERMISSION_ALIASES.transactionsView);
    const canViewAllTransactions = has(PERMISSION_ALIASES.transactionsAllView);
    return {
        canViewOwnTransactions,
        canViewAllTransactions,
        canViewTransactions: canViewOwnTransactions || canViewAllTransactions,
        canRequestInvoice: has(PERMISSION_ALIASES.paymentInvoiceRequest),
        canViewInvoices: has(PERMISSION_ALIASES.paymentInvoicesView),
        canUpdatePayment: has(PERMISSION_ALIASES.paymentInvoicePaymentUpdate),
        canReadOwnBalance:
            canViewOwnTransactions ||
            [
                UserPermission.ORDER_CREATE_CUSTOMER,
                UserPermission.ORDER_CREATE_TRANSPORT,
                UserPermission.ORDER_CREATE_CUSTOMS,
            ].some(has),
    };
}

export const billingAccess$ = permissions$.map(getBillingAccess);
